import { useState } from "react";
import { registerService } from "@/services/register.service";
import {
  findMemberInvitationTokenByEmail,
  findMemberInvitationTokenByMobile,
} from "@/services/token.service";

export type AccountStatus = "registered" | "has-invites" | "new";

export interface AccountCheckResult {
  status: AccountStatus;
  tokens: any[];
}

/**
 * Checks whether a given email/mobile belongs to a registered user,
 * an unregistered user with pending family invites, or is entirely new.
 *
 * Used by LoginForm and SignupForm to route users into the correct flow
 * before any OTP is sent.
 */
export const useAccountCheck = () => {
  const [loading, setLoading] = useState(false);

  const check = async (contact: {
    email?: string;
    mobile?: string;
  }): Promise<AccountCheckResult> => {
    setLoading(true);
    try {
      const isRegistered = await registerService.checkIfExists(contact);
      if (isRegistered) return { status: "registered", tokens: [] };

      const tokens = contact.email
        ? await findMemberInvitationTokenByEmail(contact.email)
        : await findMemberInvitationTokenByMobile(contact.mobile!);

      if (tokens.length > 0) return { status: "has-invites", tokens };

      return { status: "new", tokens: [] };
    } finally {
      setLoading(false);
    }
  };

  return { check, loading };
};
